/* Dasevikin theme JS */
document.addEventListener('DOMContentLoaded', function () {
  /* Tabs (product page) */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    tabs.querySelectorAll('.tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
        tabs.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = tabs.querySelector('[data-panel="' + btn.dataset.tab + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });

  /* Product gallery: thumbs + scroll row */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('.gallery-main img');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gal.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (main && thumb.dataset.src) main.src = thumb.dataset.src;
      });
    });

    var track = gal.querySelector('[data-gallery-track]');
    var prev = gal.querySelector('[data-gallery-prev]');
    var next = gal.querySelector('[data-gallery-next]');
    var stepSize = function () {
      var item = track ? track.querySelector('.thumb') : null;
      return item ? item.getBoundingClientRect().width + 10 : 90;
    };
    if (track && prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize() * 2, behavior: 'smooth' }); });
    if (track && next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize() * 2, behavior: 'smooth' }); });
  });

  /* Variant swatches: one row per option, keeps the hidden select in sync */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var select = picker.querySelector('[data-variant-select]');
    if (!select) return;
    var groups = picker.querySelectorAll('[data-option-index]');

    function currentOptions() {
      var values = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.variant-swatch.selected');
        values.push(active ? active.dataset.value : '');
      });
      return values;
    }

    /* Switch the main image to the one attached to the selected variant */
    function showVariantImage() {
      var opt = select.options[select.selectedIndex];
      var imgId = opt ? opt.dataset.imageId : '';
      if (!imgId) return;
      var gal = document.querySelector('[data-gallery]');
      if (!gal) return;
      var thumb = gal.querySelector('[data-gallery-thumb][data-media-id="' + imgId + '"]');
      if (thumb) {
        thumb.click();
        if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    function syncSelect() {
      var wanted = currentOptions();
      var found = null;
      Array.prototype.forEach.call(select.options, function (opt) {
        if (found) return;
        var opts = (opt.dataset.options || '').split('||');
        var match = wanted.every(function (v, i) { return !v || opts[i] === v; });
        if (match && !opt.disabled) found = opt;
      });
      if (found) {
        select.value = found.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        showVariantImage();
      }
    }

    select.addEventListener('change', showVariantImage);

    groups.forEach(function (g) {
      g.querySelectorAll('.variant-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          g.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('selected'); });
          swatch.classList.add('selected');
          syncSelect();
        });
      });
    });
  });

  /* Quantity +/- */
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.qty-box');
      var input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      if (btn.hasAttribute('data-qty-plus')) { val += 1; } else { val = Math.max(min, val - 1); }
      input.value = val;
    });
  });

  /* Carousels */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-car-track]');
    if (!track) return;
    var step = function () {
      var item = track.querySelector(':scope > *');
      return item ? item.getBoundingClientRect().width + 18 : 300;
    };
    var prev = car.querySelector('[data-car-prev]');
    var next = car.querySelector('[data-car-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  /* Hero slider */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-hero-track]');
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    var i = 0, timer = null;
    var dots = slider.querySelector('[data-hero-dots]');
    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    function go(k) {
      i = (k + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      update();
    }
    function update() {
      if (!dots) return;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('active', k === i); });
    }
    if (dots) {
      for (var k = 0; k < n; k++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.addEventListener('click', function () { go(idx); restart(); });
          dots.appendChild(b);
        })(k);
      }
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    function restart() {
      clearInterval(timer);
      var ms = parseInt(slider.dataset.interval, 10) || 6000;
      timer = setInterval(function () { go(i + 1); }, ms);
    }
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);
    update();
    restart();
  });

  /* Navigation: hover on desktop, tap on touch. Hover is handled by CSS. */
  document.querySelectorAll('[data-menu-parent]').forEach(function (parent) {
    var toggle = parent.querySelector('[data-menu-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches || window.innerWidth < 990) {
        e.preventDefault();
        var wasOpen = parent.classList.contains('open');
        document.querySelectorAll('[data-menu-parent].open').forEach(function (p) { p.classList.remove('open'); });
        if (!wasOpen) {
          parent.classList.add('open');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          toggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
    parent.addEventListener('mouseleave', function () {
      parent.classList.remove('open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-menu-parent]')) {
      document.querySelectorAll('[data-menu-parent].open').forEach(function (p) { p.classList.remove('open'); });
    }
  });

  /* Mobile menu toggle (top left hamburger) */
  document.querySelectorAll('.nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('.header-nav');
      if (nav) nav.classList.toggle('mobile-open');
    });
  });

  /* Auto-hide cart count when empty */
  document.querySelectorAll('.cart-count').forEach(function (el) {
    if (parseInt(el.textContent, 10) === 0) el.style.display = 'none';
  });
});
